import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { activateAccountRequest } from '../ducks';

const mapStateToProps = (state, props) => ({
  accountId: props.params.accountId,
  activationToken: props.params.activationToken,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      activateAccount: activateAccountRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AccountActivationContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired,
    activationToken: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { actions, accountId, activationToken } = this.props;
    actions.activateAccount({ accountId, activationToken });
  }

  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/containers/AccountActivationContainer.js